// This function allow to reference async chunks
__webpack_require__.miniCssF = (chunkId) => {
	// return url for filenames based on template
	return "static/css/" + chunkId + "." + {"637":"eef192fb","796":"0dd4f9e6"}[chunkId] + ".chunk.css";
};